import React, { useState } from 'react';

import { BaseButton, Banner, useT } from '@repo/common';
import PreviewLargerModal from './PreviewLargerModal';
import PreviewDownloadModal from './PreviewDownloadModal';
import { useResumePdfDownload } from '../../../utils/useResumePdfDownload';

import { ReactComponent as ArrowTransferIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-transfer.svg';
import { ReactComponent as ArrowBiggerIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-bigger.svg';
import { ReactComponent as DownloadIcon } from '@repo/common/assets/icons/16px/icon_16px_download.svg';

const PreviewBottom = ({
  resumeData,
  resumeTitle,
  setTotalPages,
  currentPage,
  setCurrentPage,
}) => {
  const t = useT();
  const [isLargerModalOpen, setIsLargerModalOpen] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const handleOpenLargerModal = () => setIsLargerModalOpen(true);
  const handleCloseLargerModal = () => setIsLargerModalOpen(false);

  const handleOpenDownloadModal = () => setIsDownloadModalOpen(true);
  const handleCloseDownloadModal = () => setIsDownloadModalOpen(false);

  const { handleDownload } = useResumePdfDownload(resumeData, resumeTitle);

  return (
    <div className='w-full'>
      <Banner
        type='info'
        size='s'
        label='Automatic Korean translation included'
        labelKr='한국어 자동 번역이 포함되어 있습니다'
        icon={<ArrowTransferIcon />}
      />

      <div className='w-full flex flex-row justify-end items-start gap-2 pt-4'>
        <BaseButton
          type='secondary'
          iconPosition='before'
          icon={<ArrowBiggerIcon />}
          onClick={handleOpenLargerModal}
        >
          {t('View larger', '크게 보기')}
        </BaseButton>

        <BaseButton
          type='secondary'
          iconPosition='before'
          icon={<DownloadIcon />}
          onClick={handleOpenDownloadModal}
        >
          PDF
        </BaseButton>
      </div>

      {isLargerModalOpen && (
        <PreviewLargerModal
          resumeData={resumeData}
          onClose={handleCloseLargerModal}
          setTotalPages={setTotalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onDownload={handleDownload}
        />
      )}

      {isDownloadModalOpen && (
        <PreviewDownloadModal
          onClose={handleCloseDownloadModal}
          onDownload={handleDownload}
        />
      )}
    </div>
  );
};

export default PreviewBottom;
